// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__85RR6","circle":"Preloader_circle__VNCA7"};